import Dependencies from "../utilities/dependencies";

export default class Hero {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.hero-element'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.splide];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {

		const sliderElement = holderElement.querySelector('.splide');

		if (!sliderElement) {
			return;
		}

		const sliderControls = holderElement.querySelectorAll('.slider-controls button');
		const progressBar = holderElement.querySelector('.slider-progress-bar');

		const slider = new Splide(sliderElement, {
			autoplay: sliderElement.dataset.autoPlay === 'true',
			interval: 3000,
			pagination: false,
			type: 'loop',
			arrows: false,
		});
		slider.mount();

		const updateProgress = (index) => {
			const width = Math.min(100, (index + 1 / slider.length) * 100);
			progressBar.style.width = width + '%';
		}

		slider.on('move', updateProgress);

		sliderControls.forEach(btn => btn.addEventListener('click', () => {
			slider.go(btn.value);
		}));

		updateProgress(0);
	}
}
